import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var LibSci = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.13 24.843c-.2-.199-.598-.199-.898-.199L21.95 26.64l-7.282-1.996c-.3-.1-.599 0-.898.2-.2.2-.4.498-.4.798v10.676c0 .399.3.798.699.997l7.482 1.996c.2.1.399.1.598 0l7.482-1.996c.4-.1.699-.499.699-.997V25.642c.2-.3 0-.599-.2-.799Zm-9.178 12.173-5.586-1.497v-8.58l5.586 1.496v8.58Zm7.582-1.497-5.586 1.497v-8.58l5.586-1.497v8.58ZM15.266 6.585C15.266 2.993 18.26 0 21.95 0c3.691 0 6.584 2.993 6.584 6.585 0 3.692-2.993 6.585-6.584 6.585-3.691.1-6.684-2.893-6.684-6.585Zm6.684-4.59a4.684 4.684 0 0 0-4.689 4.69 4.683 4.683 0 0 0 4.689 4.69 4.684 4.684 0 0 0 4.689-4.69 4.684 4.684 0 0 0-4.69-4.69Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.602 19.955H30.03c-1.496-2.993-4.489-4.989-8.08-4.989-3.492 0-6.584 2.095-8.08 5.088H2.296a1 1 0 0 0-.997.998 1 1 0 0 0 .997.998h2.794v20.952a1 1 0 0 0 .997.998h31.823a1 1 0 0 0 .998-.998V21.95h2.793a1 1 0 0 0 .998-.998c-.1-.499-.499-.997-1.098-.997ZM21.95 16.962c2.394 0 4.49 1.197 5.786 3.092H16.164c1.297-1.895 3.392-3.092 5.786-3.092Zm14.964 24.943H6.986V21.95h29.928v19.955Z"
  }));
});
LibSci.displayName = 'LibSci';
LibSci.defaultProps = {
  'aria-label': 'LibSci'
};
export default LibSci;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/LibSci.js
// module id = 3658
// module chunks = 11